import { render, staticRenderFns } from "./SAvatarStemdoer.vue?vue&type=template&id=0d806cda&scoped=true"
import script from "./sAvatarStemdoer.ts?vue&type=script&lang=ts&external"
export * from "./sAvatarStemdoer.ts?vue&type=script&lang=ts&external"
import style0 from "./SAvatarStemdoer.vue?vue&type=style&index=0&id=0d806cda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d806cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d806cda')) {
      api.createRecord('0d806cda', component.options)
    } else {
      api.reload('0d806cda', component.options)
    }
    module.hot.accept("./SAvatarStemdoer.vue?vue&type=template&id=0d806cda&scoped=true", function () {
      api.rerender('0d806cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-avatar-stemdoer/SAvatarStemdoer.vue"
export default component.exports